import React, { useState, useEffect, useCallback } from "react";
import NavigationBar from "../components/home/NavigationBar";
import MainBanner from "../components/home/MainBanner";
import InfoBanner from "../components/home/InfoBanner";
import BrandInfoBanner from "../components/home/BrandInfoBanner";
import axios from "axios";
import { CardViewProps } from "../components/home/NewsCardView";
import NewsCardListView from "../components/home/NewsCardListView";
import MapInfoView from "../components/home/MapInfoView";
import { useLocation } from "react-router-dom";




const Homepage: React.FC = () => {
  const [newsItems, setNewsItems] = useState<CardViewProps[]>([])
  const [offset, setOffset]     = useState<number | null>(null)
  const [hasMore, setMore] = useState(true)
  const [loading, setLoading]   = useState(false)
  const pageSize = 6 

  const fetchPage = useCallback(async () => {
    if (loading || !hasMore) return
    setLoading(true)
    const news_status = offset === null ? "" : String(offset)

    try {
      const response = await axios.post<CardViewProps[]>('/selectQueryNews', {
        news_status,
        news_flag: "y"
      })
      const data = response.data
      if (data.length < pageSize) {
        setMore(false)
      }

      setNewsItems(prev => offset === null ? data : [...prev, ...data])
      setOffset(prev => prev === null ? 0 : prev + pageSize)
    } catch(err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }, [offset, loading, hasMore])

  useEffect(() => { fetchPage()} , [])

    const {hash} = useLocation();

    useEffect(() => {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth'});
        }
      }
    }, [hash])

  return (
    <div className="App w-full h-screen">
      <img src ="/assets/images/main_banner.png" className='w-full h-auto object-cover pt-[88px]'/>
      <section className="main-section h-[600px] tablet:h-[800px] desktop:h-[500px] pb-5 w-100% bg-[#f8fcff] justify-center align-center flex position-relative p-1.5">
        <div className="main-section-container-title z-10 mt-14 mb-14 h-auto desktop:h-[600px]">
          <InfoBanner 
          title= 	{`국내 최초\n 전자영수증 플랫폼`}
          pointText=''
          subtitle={`2013년 전자영수증 발급 방법 특허 등록\n안정적이고 확장 용이한 솔루션 제공\n광범위한 POS/VAN 네트워크로 빠른 보급 가능`}
          image='/assets/images/main_platform.png'
          />
        </div>
      </section>

    <BrandInfoBanner
      title={`브랜드의 가치를 높이는\n 마케팅 기획`}
      imageURL='/assets/images/main_arrow.png'
      className="main-brand-info-section"
      subtitles={[
          "15년차 광고 대행사", 
          "크리에이티브 전략",
          "데이터 중심"
        ]}
        descriptions = {[
          "브랜드 단계에 맞춘 IMC 전략",
          "브랜드의 진짜 매력을 어필하는 기획",
          "성과 중심 마케팅 설계로 효율 최대화"
        ]}
    />

      <section className="main-global-initiative-section bg-[#f8fcff] h-[600px] tablet:h-[750px] desktop:h-[500px] pb-5 w-100% justify-center align-center flex position-relative p-1.5">
        <div className="main-global-initiative-section-container-title z-10 mt-14 mb-14">
          <InfoBanner 
          title= 	{`탄소중립의\n 글로벌 이니셔티브`}
          pointText=''
          subtitle={`일상 소비생활에서의 탄소감축 플랫폼\n국내 유일 국민 탄소 크레딧 플랫폼`}
          image='/assets/images/main_initiative.png'
          />
        </div>
      </section>
      
      <section id="main-inquiry-news-section"  onMouseDown={e => e.preventDefault()} onTouchMove={e => e.preventDefault()} className='main-inquiry-section h-auto pb-5 w-100% justify-center align-center flex position-relative p-1.5'>
        <div onMouseDown={e => e.preventDefault()} onTouchMove={e => e.preventDefault()} className='main-inquiry-section-container z-10 h-[580px]'>
          <NewsCardListView
            items={newsItems}
            onLoadMore={fetchPage}
            hasMore={hasMore}
            loading={loading}
          />
        </div>

      </section>
        <section className='main-homepage-map-info-section bg-[#f5f6f7] h-auto w-full'>
              <MapInfoView/>
        </section>
    </div>
  );
}



export default Homepage;